import SpaceBetween from '@cloudscape-design/components/space-between';
import Input from '@cloudscape-design/components/input';
import Textarea from '@cloudscape-design/components/textarea';
import Button from '@cloudscape-design/components/button';
import Toggle from '@cloudscape-design/components/toggle';

interface SearchFormProps {
  placeholder: string;
  bulkPlaceholder: string;
  bulkMode: boolean;
  onBulkModeChange: (checked: boolean) => void;
  searchValue: string;
  onSearchValueChange: (value: string) => void;
  onSearch: () => void;
}

export const SearchForm = ({
  placeholder,
  bulkPlaceholder,
  bulkMode,
  onBulkModeChange,
  searchValue,
  onSearchValueChange,
  onSearch,
}: SearchFormProps) => {
  return (
    <SpaceBetween size="m">
      {bulkMode ? (
        <SpaceBetween size="s">
          <Textarea
            value={searchValue}
            onChange={({ detail }) => onSearchValueChange(detail.value)}
            placeholder={bulkPlaceholder}
            rows={5}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Toggle
              checked={bulkMode}
              onChange={({ detail }) => onBulkModeChange(detail.checked)}
            >
              Bulk search mode
            </Toggle>
            <Button variant="primary" iconName="search" onClick={onSearch}>
              Search
            </Button>
          </div>
        </SpaceBetween>
      ) : (
        <SpaceBetween size="s">
          <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <Input
                value={searchValue}
                onChange={({ detail }) => onSearchValueChange(detail.value)}
                onKeyDown={({ detail }) => {
                  if (detail.keyCode === 13) onSearch();
                }}
                placeholder={placeholder}
                type="search"
              />
            </div>
            <Button variant="primary" iconName="search" onClick={onSearch}>
              Search
            </Button>
          </div>
          <Toggle
            checked={bulkMode}
            onChange={({ detail }) => onBulkModeChange(detail.checked)}
          >
            Bulk search mode
          </Toggle>
        </SpaceBetween>
      )}
    </SpaceBetween>
  );
};
